import { Icon } from "@/components/Icon";
import { UploadImg } from "@/components/UploadImg";
import { Form, Input } from "antd-mobile";
import styles from "./index.module.scss";
export const IdCardForm = () => {
  return <>
      <Form.Item name="realName" label="姓名" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
        <Input placeholder="请输入您的姓名" data-sentry-element="Input" data-sentry-source-file="index.tsx" />
      </Form.Item>

      <Form.Item name="idCard" label="身份证号" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
        <Input placeholder="请输入身份证号" data-sentry-element="Input" data-sentry-source-file="index.tsx" />
      </Form.Item>

      <Form.Item name="idCardFrontImg" label=" " data-sentry-element="unknown" data-sentry-source-file="index.tsx">
        <UploadImg className={styles.id_card_img} data-sentry-element="UploadImg" data-sentry-source-file="index.tsx">
          <div className={styles.id_card}>
            <div className={styles.id_card_front}>
              <div className={styles.id_card_icon}>
                <Icon name={"camera"} size={"50px"} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
              </div>
              <div className={styles.id_card_text}>拍摄身份证正面</div>
            </div>
          </div>
        </UploadImg>
      </Form.Item>

      <Form.Item name="idCardReverseImg" label="" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
        <UploadImg className={styles.id_card_img} data-sentry-element="UploadImg" data-sentry-source-file="index.tsx">
          <div className={styles.id_card}>
            <div className={styles.id_card_back}>
              <div className={styles.id_card_icon}>
                <Icon name={"camera"} size={"50px"} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
              </div>
              <div className={styles.id_card_text}>拍摄身份证背面</div>
            </div>
          </div>
        </UploadImg>
      </Form.Item>
    </>;
};